import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { toast } from "sonner";

function pad(n) { return String(n).padStart(2, "0"); }

export default function RequiredStaff() {
  const [periods, setPeriods] = useState([]);
  const [periodId, setPeriodId] = useState("");
  const [departments, setDepartments] = useState([]);
  const [positions, setPositions] = useState([]);
  const [requireds, setRequireds] = useState([]);
  const [form, setForm] = useState({ date: "", department_id: "", position_id: "", required_count: 1 });

  useEffect(() => {
    api.get("/shift-periods").then((r) => {
      setPeriods(r.data);
      if (r.data[0]) setPeriodId(r.data[0].id);
    });
    api.get("/departments").then((r) => setDepartments(r.data));
    api.get("/positions").then((r) => setPositions(r.data));
  }, []);

  const period = periods.find((p) => p.id === periodId);
  const load = () => {
    if (!period) return;
    api.get(`/required-staff?year=${period.year}&month=${period.month}`).then((r) => setRequireds(r.data));
  };
  useEffect(load, [period]);

  const save = async () => {
    try {
      await api.post("/required-staff", { ...form, required_count: parseInt(form.required_count, 10) });
      toast.success("保存しました");
      load();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  const del = async (id) => {
    try {
      await api.delete(`/required-staff/${id}`);
      load();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <div className="space-y-4" data-testid="required-staff-page">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl md:text-3xl font-bold tracking-tight text-slate-900">必要人数設定</h1>
        <Select value={periodId} onValueChange={setPeriodId}>
          <SelectTrigger className="w-56 bg-white"><SelectValue /></SelectTrigger>
          <SelectContent>
            {periods.map((p) => (
              <SelectItem key={p.id} value={p.id}>{p.year}年{p.month}月分</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <Card className="p-4 bg-white border border-slate-200">
        <h2 className="text-sm font-bold text-slate-900 mb-2">追加・更新</h2>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-2 items-end">
          <Input data-testid="req-date" type="date" value={form.date} onChange={(e) => setForm({...form, date: e.target.value})} />
          <Select value={form.department_id} onValueChange={(v) => setForm({...form, department_id: v})}>
            <SelectTrigger data-testid="req-dept"><SelectValue placeholder="部署" /></SelectTrigger>
            <SelectContent>
              {departments.map((d) => <SelectItem key={d.id} value={d.id}>{d.name}</SelectItem>)}
            </SelectContent>
          </Select>
          <Select value={form.position_id || "_none"} onValueChange={(v) => setForm({...form, position_id: v === "_none" ? "" : v})}>
            <SelectTrigger data-testid="req-pos"><SelectValue placeholder="職種 (任意)" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="_none">指定なし</SelectItem>
              {positions.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}
            </SelectContent>
          </Select>
          <Input data-testid="req-count" type="number" min={1} value={form.required_count} onChange={(e) => setForm({...form, required_count: e.target.value})} />
          <Button data-testid="req-save-button" onClick={save} className="bg-blue-600 hover:bg-blue-700">保存</Button>
        </div>
      </Card>

      <Card className="p-4 bg-white border border-slate-200">
        <h2 className="text-sm font-bold text-slate-900 mb-2">設定一覧</h2>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-slate-500 border-b border-slate-200">
                <th className="py-2 px-2">日付</th>
                <th className="py-2 px-2">部署</th>
                <th className="py-2 px-2">職種</th>
                <th className="py-2 px-2">人数</th>
                <th className="py-2 px-2"></th>
              </tr>
            </thead>
            <tbody>
              {requireds.map((r) => (
                <tr key={r.id} className="border-b border-slate-100">
                  <td className="py-2 px-2">{r.date}</td>
                  <td className="py-2 px-2">{departments.find((d) => d.id === r.department_id)?.name}</td>
                  <td className="py-2 px-2">{positions.find((p) => p.id === r.position_id)?.name || "-"}</td>
                  <td className="py-2 px-2 font-semibold">{r.required_count}</td>
                  <td className="py-2 px-2">
                    <Button size="sm" variant="outline" data-testid={`del-req-${r.id}`} onClick={() => del(r.id)}>削除</Button>
                  </td>
                </tr>
              ))}
              {requireds.length === 0 && (
                <tr><td colSpan={5} className="py-3 text-center text-slate-400">設定がありません</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
